// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;

        font-family: "Montserrat";
}

.loader {
        text-align: center;
}

.blur-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-backdrop-filter: blur(10px);
                backdrop-filter: blur(10px);
        z-index: -1;
}

/* Loader*/

.loader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
}

.loader-text {
        font-size: 36px;
        white-space: nowrap;
        overflow: hidden;
        width: auto;
        height: auto;
        position: relative;

        font-family: "Montserrat";
}

.loader-text span {
        animation: color-change 1s infinite alternate;
        display: inline-block;
}

@keyframes color-change {
        0% {
                color: #ffffff; /* Red color */
        }
        50% {
                color: #ff0000; /* Black color */
        }
        100% {
                color: #ffffff; /* Red color */
        }
}

@keyframes new-animation {
        0% {
                transform: scale(0);
                opacity: 0;
        }
        50% {
                transform: scale(1.2);
                opacity: 1;
        }
        100% {
                transform: scale(1);
                opacity: 0;
        }
}

.cursor {
        border-right: 1px solid;
        padding-left: 2px;
}

.loading-message {
        margin-top: 20px;
        color: #ffffff; /* Set the loading message color to black */
        display: inline-block;
        position: relative;
}

.loading-message .dot:nth-child(1) {
        animation: dot-animation 1.5s infinite;
        animation-delay: 0s;
        color: #ffffff; /* Set the loading message color to black */
        font-size: medium;
}

.loading-message .dot:nth-child(2) {
        animation: dot-animation 1.5s infinite;
        animation-delay: 0.5s;
}

.loading-message .dot:nth-child(3) {
        animation: dot-animation 1.5s infinite;
        animation-delay: 1s;
}

@keyframes dot-animation {
        0% {
                opacity: 0;
                transform: translateY(0);
        }
        50% {
                opacity: 1;
                transform: translateY(-5px);
        }
        100% {
                opacity: 0;
                transform: translateY(0);
        }
}`, "",{"version":3,"sources":["webpack://./src/components/TextLoader/TextLoader.css"],"names":[],"mappings":"AAAA;QACQ,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,oCAAoC;QACpC,YAAY;;QAEZ,yBAAyB;AACjC;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;QACQ,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,mCAA2B;gBAA3B,2BAA2B;QAC3B,WAAW;AACnB;;AAEA,UAAU;;AAEV;QACQ,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,aAAa;AACrB;;AAEA;QACQ,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;QACX,YAAY;QACZ,kBAAkB;;QAElB,yBAAyB;AACjC;;AAEA;QACQ,6CAA6C;QAC7C,qBAAqB;AAC7B;;AAEA;QACQ;gBACQ,cAAc,EAAE,cAAc;QACtC;QACA;gBACQ,cAAc,EAAE,gBAAgB;QACxC;QACA;gBACQ,cAAc,EAAE,cAAc;QACtC;AACR;;AAEA;QACQ;gBACQ,mBAAmB;gBACnB,UAAU;QAClB;QACA;gBACQ,qBAAqB;gBACrB,UAAU;QAClB;QACA;gBACQ,mBAAmB;gBACnB,UAAU;QAClB;AACR;;AAEA;QACQ,uBAAuB;QACvB,iBAAiB;AACzB;;AAEA;QACQ,gBAAgB;QAChB,cAAc,EAAE,2CAA2C;QAC3D,qBAAqB;QACrB,kBAAkB;AAC1B;;AAEA;QACQ,sCAAsC;QACtC,mBAAmB;QACnB,cAAc,EAAE,2CAA2C;QAC3D,iBAAiB;AACzB;;AAEA;QACQ,sCAAsC;QACtC,qBAAqB;AAC7B;;AAEA;QACQ,sCAAsC;QACtC,mBAAmB;AAC3B;;AAEA;QACQ;gBACQ,UAAU;gBACV,wBAAwB;QAChC;QACA;gBACQ,UAAU;gBACV,2BAA2B;QACnC;QACA;gBACQ,UAAU;gBACV,wBAAwB;QAChC;AACR","sourcesContent":[".loader-container {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 999;\n\n        font-family: \"Montserrat\";\n}\n\n.loader {\n        text-align: center;\n}\n\n.blur-background {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        backdrop-filter: blur(10px);\n        z-index: -1;\n}\n\n/* Loader*/\n\n.loader-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 100vh;\n}\n\n.loader-text {\n        font-size: 36px;\n        white-space: nowrap;\n        overflow: hidden;\n        width: auto;\n        height: auto;\n        position: relative;\n\n        font-family: \"Montserrat\";\n}\n\n.loader-text span {\n        animation: color-change 1s infinite alternate;\n        display: inline-block;\n}\n\n@keyframes color-change {\n        0% {\n                color: #ffffff; /* Red color */\n        }\n        50% {\n                color: #ff0000; /* Black color */\n        }\n        100% {\n                color: #ffffff; /* Red color */\n        }\n}\n\n@keyframes new-animation {\n        0% {\n                transform: scale(0);\n                opacity: 0;\n        }\n        50% {\n                transform: scale(1.2);\n                opacity: 1;\n        }\n        100% {\n                transform: scale(1);\n                opacity: 0;\n        }\n}\n\n.cursor {\n        border-right: 1px solid;\n        padding-left: 2px;\n}\n\n.loading-message {\n        margin-top: 20px;\n        color: #ffffff; /* Set the loading message color to black */\n        display: inline-block;\n        position: relative;\n}\n\n.loading-message .dot:nth-child(1) {\n        animation: dot-animation 1.5s infinite;\n        animation-delay: 0s;\n        color: #ffffff; /* Set the loading message color to black */\n        font-size: medium;\n}\n\n.loading-message .dot:nth-child(2) {\n        animation: dot-animation 1.5s infinite;\n        animation-delay: 0.5s;\n}\n\n.loading-message .dot:nth-child(3) {\n        animation: dot-animation 1.5s infinite;\n        animation-delay: 1s;\n}\n\n@keyframes dot-animation {\n        0% {\n                opacity: 0;\n                transform: translateY(0);\n        }\n        50% {\n                opacity: 1;\n                transform: translateY(-5px);\n        }\n        100% {\n                opacity: 0;\n                transform: translateY(0);\n        }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
